module.exports = __webpack_public_path__ + "static/drawer-logos-c88ea4b5494d2423868aa9336c2af222.png";